<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {EVENT_ATTENDEES} from '../../../../graphql/events';
  
  const client = getContext('apollo');

  import Loader from '../../../../components/ui/loader.html';
  import Attendee from '../attendee.html';
  import Household from '../household.html';
  import Search from '../../../../components/inputs/search.html';
  import SectionNav from '../../../../components/navigation/section';
  import AddAttendees from '../forms/add.attendees.html';
  import TextInput from '../../../../components/inputs/text.html';
  import Form from '../../../../components/inputs/form.html';

  export let program;
  export let id;

  let search = {id: id};
  let query = client.watchQuery({ query: EVENT_ATTENDEES, variables: {id, waitlist: true} });
  let results = {loading: true};
  let adding = false;
  let filter;
  let _data;

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      registrations: data && data.event ? data.event.registrations : []
    }

    _data = data && data.event ? data.event.registrations : []
  } 

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchPeople() {
    query.refetch({search, page: 1});
  }

  function filterResults() {
    if(!filter) {
      results = {
        loading: results.loading,
        registrations: _data
      }
      return;
    }

    results = {
      loading: results.loading,
      registrations: _data.filter((registration) => {
        
        for(let person of registration.people) {
          
          if(person.firstName.toLowerCase().indexOf(filter) > -1) {
            return true;
          }

          if(person.lastName.toLowerCase().indexOf(filter) > -1) {
            return true;
          }
        }
      })
    }
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          people: {
            ...fetchMoreResult.events,
            docs: [...prev.events.docs, ...fetchMoreResult.events.docs]
          }
        });
      }
    });
  }

  function toggleAddRegistration() {
    adding = adding ? false : true;
  }

  function getDownloadLink() {
    return `${GRAPHQL_API}/events/${id}/waitlist`
  }

</script>

{#if !adding}
<div transition:fade="{{duration:200}}" class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <!--<div class="cell small-12 medium-12">
      <Search placeholder="Search Attendees" />
    </div>-->
    <div class="cell small-12 medium-12">
      {#if results.loading}
        <Loader></Loader>
      {/if}
      {#if !results.loading}
        <div class="grid-x grid-margin-x small-up-1">
          {#each results.registrations as attendee, i (attendee.id)}
            <div class="cell">
              <Attendee event={id} waitlist={true} attendee={attendee} />
            </div>
          {/each}
        </div>
        {#if results.registrations.length === 0}
          <div class="callout">
            <p>There are no waitlist registrations for this event.</p>
          </div>
        {/if}
      {/if}
    </div>
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav>
        <Form frameless> 
            <div class="grid-x grid-margin-x">
              <div class="cell small-12 medium-12">
                <div class="form-group">
                  <TextInput
                    on:input="{filterResults}"
                    bind:value={filter}
                    label="Registration Name"
                    placeholder="Search Registrations"
                  ></TextInput>
                </div>
              </div>
              
              
    
              
            </div>
          </Form>
      <div on:click={toggleAddRegistration} class="save bottom">ADD REGISTRATION</div>
      <div class="text-center" slot="under">
        
          <a target="_blank" href="{getDownloadLink()}">Download Waitlist</a>
        </div>
    </SectionNav>
  </div>
</div>
{:else}

<div transition:fade="{{duration:200}}" class="grid-x grid-margin-x">
    <div class="cell small-12 medium-9">
        <AddAttendees waitlist={true} event={id} />
    </div>
    <div class="cell small-12 medium-3">
      <SectionNav>
        <div on:click={toggleAddRegistration} class="save">CANCEL</div>
        
      </SectionNav>
    </div>
  </div>

{/if}
